import { createRoot } from "react-dom/client";
import React from "react";
import { PaywallCheckoutApp } from "@circle-react/apps/PaywallCheckoutApp";

(function() {
  if (!Object.hasOwn) {
    Object.defineProperty(Object, "hasOwn", {
      value: (object, property) => Object.prototype.hasOwnProperty.call(object, property),
    });
  }

  const element = document.getElementById("paywall-checkout-root");
  const paywallId = element.dataset.paywallId;
  const root = createRoot(element);
  root.render(React.createElement(PaywallCheckoutApp, { paywallId: Number(paywallId) }));
})();
